import React from 'react';
import {
    Form,
    ControlLabel,
    FormGroup,
    FormControl,
    Row,
    Col
} from 'react-bootstrap'

class ClubRegistrationFourthStep extends React.Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.clubSeason = {
            clubSeasonId: 0,
            freeNarrative: ''
        }
        this.setDefaultValues = this.setDefaultValues.bind(this);
        this.setDataOnModel = this.setDataOnModel.bind(this)
    }
    componentDidMount() {
        this.props.onRef(this);
        this.setDefaultValues();

    }
    setDefaultValues() {
        this.clubSeason = {
            clubSeasonId: this.props.clubRegistrationModel['clubSeason.clubSeasonId'],
            freeNarrative: this.props.clubRegistrationModel['clubSeason.freeNarrative']
        }
        this.forceUpdate()
    }
    handleChange(e) {
        this.clubSeason = {
            clubSeasonId: Number(e.target.value),
            freeNarrative: e.target.selectedOptions[0].text
        }
    }

    onSubmit(model) {
        this.setDataOnModel(model)
        let fileds = [this.clubSeason.clubSeasonId];
        let isValid = model.isValid(fileds);
        return isValid;
    }
    setDataOnModel(model) {
        model.setFourthStadiumData(this.clubSeason.clubSeasonId, this.clubSeason.freeNarrative);
    }

    render() {
        let { composingLabel, clubSeasons } = this.props;
        return (
            <Form name='fourthStageForm'>
                <fieldset className='registrationFieldSet'>
                    <legend className="registerFieldsetLabel">{composingLabel('sportOauthLabel.sportSeason', 'Sport season')}</legend>
                    < Row className="show-grid" >
                        <Col className='registerFormGroupCol' lg={6} md={12} sm={12} xs={12}>
                            <FormGroup className='registerFormGroup' controlId="secondStadiumCountryText">
                                <Col componentClass={ControlLabel} lg={6} md={6} sm={6} xs={12} className='registerFieldLabel'>{composingLabel('sportOauthLabel.chooseSeason', 'Choose season', false)}</Col>
                                <Col lg={6} md={6} sm={6} xs={12} >
                                    <FormControl className='registerField' className='registerField' componentClass="select"
                                        name='clubSeason'
                                        defaultValue={this.clubSeason.clubSeasonId}
                                        onChange={this.handleChange}>
                                        <option value={this.clubSeason.clubSeasonId}>{this.clubSeason.freeNarrative ? this.clubSeason.freeNarrative : ''}</option>
                                        {clubSeasons.map(clubSeason => {
                                            return <option key={clubSeason.clubSeasonId} value={clubSeason.clubSeasonId}>
                                                {clubSeason.freeNarrative}
                                            </option>
                                        })}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                </fieldset>
            </Form >
        )
    }
}

export default ClubRegistrationFourthStep;


// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/ClubRegistrationFourthStep.js